/* eslint-disable @typescript-eslint/no-unused-vars */
function showOptions(data, mKey, questionId, qLevel, isMultiSelect) {
  data = data.sort((a, b) => a.orderNo - b.orderNo);
  let options = isMultiSelect
    ? ""
    : `<option value='' data-key='${mKey}' data-current-question='${questionId}' data-question-level='${qLevel}'>Select</option>`;
  options = options.concat(
    data.map(
      (d) =>
        `<option value='${d.id}' data-key='${mKey}' data-ishierarchy='${d.isHierarchy}' data-hierarchy-question='${d.hierarchyQuestionId}' data-current-question='${questionId}' data-question-level='${d.questionLevel}'>${d.optionText}</option>`
    )
  );
  return options;
}

function showRadioOptions(questionId, data, mKey, qLevel) {
  data = data.sort((a, b) => a.orderNo - b.orderNo);
  let radioOptions = "";
  for (let i = 0; i < data.length; i++) {
    radioOptions = radioOptions.concat(
      `<label class='flex items-center gap-3 px-3 py-2.5 mb-0 text-sm border rounded cursor-pointer border-line bg-surface text-ink-2 hover:bg-surface-hover'><input type='radio' class='showChildQuestion qid_${questionId} w-4 h-4 shrink-0 accent-primary' name='${questionId}' id='${questionId}' value=${data[i].id} data-key='${mKey}' data-ishierarchy='${data[i].isHierarchy}' data-hierarchy-question='${data[i].hierarchyQuestionId}' data-current-question='${questionId}' data-question-level='${data[i].questionLevel}'> <span>${data[i].optionText}</span></label>`
    );
  }
  return radioOptions;
}

export function TextBox(questionId, mKey, qLevel) {
  return `<input type='text' name='${questionId}' id='${questionId}' class='zs-input'/>`;
}

export function Multiselect(questionId, options, mKey, qLevel) {
  const isMultiSelect = true;
  return `<select class='form-control js-example-basic-multiple showChildQuestionSelect' style='width:100%; height: 40px;' name='${questionId}' id='${questionId}' multiple='multiple'>${showOptions(
    options,
    mKey,
    questionId,
    qLevel,
    isMultiSelect
  )}</select>
`;
}

export function Dropdown(questionId, options, mKey, qLevel) {
  const isMultiSelect = false;
  return `<select class='cursor-pointer zs-select showChildQuestionSelect' name='${questionId}' id='${questionId}'>${showOptions(
    options,
    mKey,
    questionId,
    qLevel,
    isMultiSelect
  )}</select>`;
}

export function Radio(questionId, options, mKey, qLevel) {
  return "<div class='grid gap-2 sm:grid-cols-2'>" + showRadioOptions(questionId, options, mKey, qLevel) + "</div>";
}
